'use strict';

var React = require('react');
var Theme = require('../../Theme/Theme.js');
var DarkTheme = require('../../Theme/DarkTheme.js');
var LightTheme = require('../../Theme/LightTheme.js');
var ThemeProvider = require('../../node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function getTheme(mode) {
  if (mode === "dark") {
    return DarkTheme.darkTheme;
  }

  if (mode === "light") {
    return LightTheme.lightTheme;
  }

  return Theme.theme;
}

function HousecallThemeProvider(_ref) {
  var children = _ref.children,
      mode = _ref.mode;
  return React__default["default"].createElement(ThemeProvider, {
    theme: getTheme(mode)
  }, children);
}

module.exports = HousecallThemeProvider;
